import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import DeviceVideo from 'components/DeviceVideo/DeviceVideo';
import Modal from 'components/Modal/Modal';
import Block from 'components/structure/Block/Block';
import { paddingBuilder } from 'styles/themeUtils';

import { BlockHiddenOnMobile } from './styles/BlockHiddenOnMobile';
import { ModalTriggerButton } from './styles/ModalTriggerButton';
import { StyledDeviceVideo } from './styles/DeviceVideo';
import { TabContent } from './styles/TabContent';

class ExplainTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
  }

  handleToggleModal = () => {
    this.setState(state => ({ modalOpened: !state.modalOpened }));
  };

  render() {
    const { videoId, title, copy } = this.props;
    const { modalOpened } = this.state;

    return (
      <TabContent>
        <BlockHiddenOnMobile
          padding={{
            default: paddingBuilder.all(0),
            tablet: paddingBuilder.all(0),
          }}
        >
          <StyledDeviceVideo videoId={videoId} />
        </BlockHiddenOnMobile>
        <Block
          padding={{
            default: paddingBuilder.all(0),
            tablet: paddingBuilder.left(2),
          }}
        >
          <Typography
            variant="title"
            color="black"
            colorVariant="default"
            marginBottom="8x"
            tag="span"
            whiteSpace="pre-line"
          >
            {title}
          </Typography>
          <Typography
            variant="paragraph2"
            marginBottom="8x"
          >
            {copy}
          </Typography>
          <ModalTriggerButton
            variant="basic"
            color="primary"
            onClick={this.handleToggleModal}
            id={videoId}
          >
            Como funciona?
          </ModalTriggerButton>
          <Modal
            isOpen={modalOpened}
            onModalClose={this.handleToggleModal}
            ariaId={videoId}
          >
            <DeviceVideo videoId={videoId} />
          </Modal>
        </Block>
      </TabContent>
    );
  }
}

ExplainTab.propTypes = {
  copy: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
};

export default ExplainTab;
